import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Home, MessageSquare, CalendarDays, Mail, Settings, TrendingUp } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'

const navItems = [
  { href: '/dashboard', label: 'Home', icon: Home },
  { href: '/dashboard/chat', label: 'Chat', icon: MessageSquare },
  { href: '/dashboard/calendar', label: 'Calendar', icon: CalendarDays },
  { href: '/dashboard/sales', label: 'Sales', icon: TrendingUp },
  { href: '/dashboard/settings', label: 'Settings', icon: Settings },
]

export const BottomNav: React.FC = () => {
  const { currentTheme } = useTheme()
  const location = useLocation()
  const pathname = location.pathname

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 flex items-stretch h-16"
      style={{
        background: currentTheme.sidebarBg,
        borderTop: `1px solid ${currentTheme.sidebarBorder}`,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {navItems.map(({ href, label, icon: Icon }) => {
        const isActive = pathname === href
        return (
          <Link
            key={href}
            to={href}
            className="flex-1 flex flex-col items-center justify-center gap-1"
            style={{ color: isActive ? currentTheme.sidebarActiveText : currentTheme.sidebarText }}
          >
            <Icon className="w-5 h-5" strokeWidth={isActive ? 2.25 : 1.75} style={{ color: isActive ? currentTheme.accent : 'inherit' }} />
            <span className="text-[11px] leading-none" style={{ fontWeight: isActive ? 600 : 500 }}>
              {label}
            </span>
          </Link>
        )
      })}
    </nav>
  )
}

export default BottomNav
